// Keys are generated, never typed by a partner: a hand-written identifier is how
// two fields collide, and answers are filed under the key forever.

const keyMaxLength = 32;
const fallbackKey = "pole";

export function customFieldKeyFromLabel(label: string, takenKeys: readonly string[]): string {
  const slug = slugify(label);
  const base = (startsWithLetter(slug) ? slug : `${fallbackKey}_${slug}`).slice(0, keyMaxLength);
  const candidate = trimSeparators(base) || fallbackKey;
  return takenKeys.includes(candidate) ? nextFreeKey(candidate, takenKeys) : candidate;
}

function slugify(label: string): string {
  const withoutDiacritics = label.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return trimSeparators(withoutDiacritics.toLowerCase().replace(/[^a-z0-9]+/g, "_"));
}

function nextFreeKey(base: string, takenKeys: readonly string[]): string {
  for (let suffix = 2; ; suffix++) {
    const room = keyMaxLength - String(suffix).length - 1;
    const candidate = `${trimSeparators(base.slice(0, room))}_${suffix}`;
    if (!takenKeys.includes(candidate)) return candidate;
  }
}

function startsWithLetter(value: string): boolean {
  return /^[a-z]/.test(value);
}

function trimSeparators(value: string): string {
  return value.replace(/^_+|_+$/g, "");
}
